import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderStatus',
})
export class OrderStatusPipe implements PipeTransform {
  orderStatus: string = '';

  /**
   * get the orderStaus string and return the Case status translation Key
   * @param value
   * @param args
   * @returns orderStatus string translation Key
   */
  transform(value: string, ..._args: unknown[]): string {
    switch (value.toLowerCase()) {
      //here case.status Cases
      case 'orderinitiated': {
        this.orderStatus = 'CASE_STATUS.ORDERINITIATED';
        return this.orderStatus;
      }
      case 'orderinprogress': {
        this.orderStatus = 'CASE_STATUS.ORDERINPROGRESS';
        return this.orderStatus;
      }
      case 'ordercompleted': {
        this.orderStatus = 'CASE_STATUS.FINISHED';
        return this.orderStatus;
      }
      case 'orderforapproval': {
        this.orderStatus = 'CASE_STATUS.ORDERFORAPPROVAL';
        return this.orderStatus;
      }

      //here case.poStatus cases
      case '1': {
        this.orderStatus = 'PO_STATUS.PAYMENT_INTINATED_PAYONE';
        return this.orderStatus;
      }
      case '-1': {
        this.orderStatus = 'PO_STATUS.PAYONE_FAILED_HEADER';
        return this.orderStatus;
      }
      case '-2': {
        this.orderStatus = 'PO_STATUS.UNKNOWN_ERROR';
        return this.orderStatus;
      }
    }
    return this.orderStatus;
  }
}
